import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { maybe } from "shared/maybe";
export default function ThumbnailBox(props) {
    const classes = [
        "d-flex",
        props.border !== false ? "border " + maybe(props.variant, variant => "border-" + variant, () => "") : "border-0",
        ...props.border !== false && props.highlighted ? ["shadow-" + (props.variant ?? "primary")] : [],
    ];
    const variant = props.variant ?? "light";
    const variantClass = "text-" + variant + "-emphasis bg-" + variant + "-subtle";
    const style = {
        ...(() => {
            if (props.aspectRatio === undefined) {
                return {
                    aspectRatio: 1,
                    overflow: "hidden",
                    width: "100%"
                };
            }
            else {
                return {
                    aspectRatio: [props.aspectRatio].flat().join(" / ")
                };
            }
        })(),
        cursor: typeof props.onClick === "function" ? "pointer" : undefined,
    };
    return (_jsx("div", { className: classNames(classes, variantClass), style: style, onClick: props.onClick === "nothing" ? undefined : props.onClick, onDoubleClick: props.onDoubleClick, children: props.children }));
}
